<template lang="html">
    <div class="tab-index">
        <!--阿里登录-->
<!--        <div class="fd-alogin-box">-->
<!--            <AlLogin></AlLogin>-->
<!--        </div>-->
        <!--<Login></Login>-->
        <div class="fd-banner">
            <h3></h3>
            <div class="fd-title">
                <div class="fd-title-inner">
                    <img class="title-logo" src="../../assets/image/login.png" alt="">
                    <div class="title-cont">
                        <h2>网上保全</h2>
                        <span>便捷  高效  一站式保全服务平台</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="apply-content">
            <div class="apply-preservation">
                <h4>我要申请保全</h4>
                <button class="fd-apply-button" @click="createPreservation">立即申请</button>
<!--                <button class="fd-apply-button" @click="createReconsider">申请复议</button>-->
                <span class="text-info">
                    实现网上保全一键申请、快速审批、网上交费、在线裁定的一站式服务。
                </span>
                <img src="../../assets/image/icon-sqbq.png" alt="">
            </div>
            <div class="apply-preservation" @click="createGuarantee">
                <h4>我要申请担保</h4>
                <button class="fd-apply-button">立即申请</button>
                <span class="text-info">
                    提供覆盖全国的网上担保服务，担保机构权威认可、快速报价、急速出函。
                </span>
                <img src="../../assets/image/icon-sqdb.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    import {Dialog,Toast} from "vant";
    import {setToken} from '@/utils/auth';
    import {CryptoJS} from '@/utils/aes'
    export default {
        data() {
            return {
                isPerfectInfo:false,
                nUsersource:0,
            }
        },
        components: {

        },
        methods: {
            //查看信息是否完善
            perfectInfo(){
                //TODO
                this.$axios.post('account/api/account/userVerifyWfy')
                //  this.$axios.post('account/api/account/userVerificode')
                    .then(res => {
                        if (res.data && res.data.user == false) {
                            // 如果未实名提示跳转完善个人信息, 此处比较的是字符串true
                            // 请完善个人信息
                            Dialog.confirm({
                                title: '提示',
                                message: '请完善个人信息',
                                confirmButtonColor: '#ffffff',
                                cancelButtonColor: '#ffffff'
                            }).then(() => {
                                this.$router.push("/seeUserDetails");
                            }).catch(() => {

                            });
                        }else{
                            this.isPerfectInfo = true
                        }
                    });
            },
            /* 清空权限字 */
            clearPowerKeys(){
                sessionStorage.removeItem('powerKeys_cBqlb');
                sessionStorage.removeItem('powerKeys_cBqlx');
                sessionStorage.removeItem('powerKeys_cFysx');
            },
            createGuarantee() {
                // 关闭申请担保流程
                // this.clearPowerKeys()
                // Toast('该功能暂未开通小程序端，请使用电脑进行申请！');
                // return false;

                // 打开申请担保流程
                if(this.isPerfectInfo == true){
                    this.$router.push({
                        path: "/createGuarantee",
                    });
                }else{
                    Dialog.confirm({
                        title: '提示',
                        message: '请完善个人信息',
                        confirmButtonColor: '#ffffff',
                        cancelButtonColor: '#ffffff'
                    }).then(() => {
                        this.$router.push("/seeUserDetails");
                    }).catch(() => {

                    });
                }
            },
            /**
             * 提示完善个人信息
             * */
            perfectInfoConfirm() {
                Dialog.confirm({
                    title: '提示',
                    message: '请完善个人信息',
                    confirmButtonColor: '#ffffff',
                    cancelButtonColor: '#ffffff'
                }).then(() => {
                    this.$router.push("/seeUserDetails");
                }).catch(() => {

                });
            },
            createPreservation() {
                if(this.isPerfectInfo == true){
                    this.$router.push({
                        path: "/preservationNotice",
                    });
                }else {
                    // 提示完善个人信息
                    this.perfectInfoConfirm();
                }
            },
            //申请复议
            createReconsider(){
                this.$router.push({
                    path: "/reconsiderBasic",
                });
            },
            //解密
            decrypt(data, key) {
                return ((CryptoJS.AES.decrypt(data, key)).toString(CryptoJS.enc.Utf8));
            },
            //获取小程序参数
            getQueryString(){
                //let url = window.location.search; //获取url中"?"符后的字串
                console.log('--获取小程序参数 111',window.location);
                let url = window.location.href; //获取url中"?"符后的字串
                url=url.substring(url.indexOf('?'),url.length);
                console.log('--获取小程序参数 222',url);
                let theRequest = new Object();
                if (url.indexOf("?") != -1) {
                    let str = url.substr(1);
                    let strs = str.split("&");
                    for(let i = 0; i < strs.length; i ++) {
                        theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);
                    }
                }
                //存储登录源
                window.sessionStorage.setItem("logSource",theRequest.status)
                //console.log('--获取小程序参数 111',theRequest);
                //存储加密的token
                if(theRequest.cUserid){
                    //let encryToken = ((CryptoJS.AES.decrypt(theRequest.token,"1234abcdef567")).toString(CryptoJS.enc.Utf8))
                    let encryToken=theRequest.token;
                    setToken(encryToken);
                    console.log('--登陆成功 111',encryToken);
                    // this.$notify({
                    //     type: 'success',
                    //     message: '登录成功'
                    // });
                }
                window.addEventListener('message', (e) => {
                    let res = {
                        message: ''
                    };
                    try {
                        res = JSON.parse(e.data)
                    } catch (e) {
                        console.log("获取令牌捕捉错误信息",e);
                    }
                    //消息类型
                    if (res.message == '获取令牌成功') {
                        if (res.data.cUserid) {
                            setToken(res.data.token);
                            this.$notify({
                                type: 'success',
                                message: '登录成功'
                            });
                        } else {
                            console.log("获取令牌好像失败了");
                        }
                    }
                })
                return theRequest;
            },
        },
        created() {
             this.logStatus = window.sessionStorage.getItem("logSource")
            if(this.logStatus != 1){
                this.nUsersource = 2
            }
            this.getQueryString()
            this.perfectInfo()
        }
    }
</script>

<style lang="less" scoped>
    .tab-index {
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        position: relative;
        background: #f3f3f3;
        z-index:99;
        .fd-banner {
            width: 100%;
            height: 51%;
            background: url('../../assets/image/icon-head.png') no-repeat center center;
            position: absolute;

            > h3 {
                font-size: 18px;
                color: #fff;
                text-align: center;
                padding-top: 30px/2;
            }

            .fd-title {
                padding-top: 40px;
                padding-bottom: 76px/2;

                .fd-title-inner {
                    width: 60%;
                    margin-left: 20%;
                    display: flex;

                    .title-logo {
                        width: 106px/2;
                        height: 106px/2;
                        margin-top: 5px;
                        flex-shrink: 0;
                    }
                }

                .title-cont {
                    padding-left: 16px;

                    > h2 {
                        font-size: 30px;
                        color: #fff;
                        text-align: left;
                        font-weight: bold;
                        letter-spacing: 5px;
                    }

                    > span {
                        font-size: 14px;
                        color: #fff;
                        display: block;
                        text-align: left;
                        margin-top: 4px;
                        white-space: nowrap;
                    }
                }
            }
        }

        .apply-content {
            padding-top: 300px/2;
            width: 90%;
            margin-left: 5%;
        }

        .apply-preservation {
            width: 100%;
            background: #fff;
            margin-bottom: 20px/2;
            border-radius: 12px/2;
            height: 420px/2;
            padding: 18px;
            position: relative;
            box-shadow: 0 5px/2 8px/2 #e2e2e2;
            box-sizing: border-box;

            > h4 {
                font-size: 20px;
                font-weight: bold;
            }

            .text-info {
                color: #666;
                display: block;
                width: 190px;
                line-height: 22px;
                margin-top: 12px;
            }

            > img {
                position: absolute;
                right: 8px;
                top: 50px;
                width: 240px/2;
                height: 206px/2;
            }
        }
    }

    .fd-apply-button {
        color: #fff;
        background: linear-gradient(to right, #ffbe03, #ff9b00);
        margin-right: 0.32rem;
        width: 90px;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        border-radius: 15px;
        display: inline-block;
    }
</style>
